{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"__experimental": true,
	"apiVersion": 3,
	"name": "core/tab",
	"title": "Tab",
	"description": "Content for a tab in a tabbed interface.",
	"version": "1.0.0",
	"category": "design",
	"textdomain": "default",
	"attributes": {
		"label": {
			"type": "string",
			"default": ""
		}
	},
	"parent": [ "core/tab-panel" ],
	"usesContext": [
		"core/tabs-activeTabIndex",
		"core/tabs-editorActiveTabIndex",
		"core/tabs-id"
	],
	"supports": {
		"anchor": true,
		"html": false,
		"reusable": false,
		"color": {
			"background": true,
			"text": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"layout": true,
		"spacing": {
			"blockGap": true,
			"padding": true,
			"margin": false
		},
		"typography": {
			"fontSize": true,
			"__experimentalFontFamily": true,
			"__experimentalDefaultControls": {
				"fontSize": true,
				"__experimentalFontFamily": true
			}
		},
		"renaming": true
	},
	"providesContext": {
		"core/tab-label": "label"
	},
	"editorScript": "file:./index.js",
	"style": "file:./style-index.css"
}
